import * as mutationTypes from './mutation-types'
import api from '@/store/api/sipcentric'
// Modules
import customer from './customer'
import {mapLegacyPagination} from '@/store/utils'

const initialState = () => ({
    customers: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        customers: state => state.customers.data,
        pagination: state => state.customers.pagination
    },
    actions: {
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listCustomers: async ({commit, dispatch}, params) => {
            try {
                const response = await api.listCustomers(params)
                commit(mutationTypes.SET_CUSTOMERS, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetCustomers: ({commit}) => commit(mutationTypes.RESET_CUSTOMERS)
    },
    modules: {
        customer
    },
    mutations: {
        [mutationTypes.RESET_CUSTOMERS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_CUSTOMERS]: (state, data) => {
            const {data: customers, pagination} = data

            state.customers = {
                data: customers,
                pagination: mapLegacyPagination(pagination)
            }
        }
    }
}
